import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getMagazineCategoriesUseCase } from "../useCases/getMagazineCategoriesUseCase";

export const useMagazineCategories = () => {
    const navigate = useNavigate();

    useEffect(() => {
        getMagazineCategoriesUseCase();
    }, []);

    const onGoToCreateMagazineCategory = useCallback(() => {
        navigate('/dashboard/magazine-categories/create');
    }, []);

    return { onGoToCreateMagazineCategory };
}